
import { Vue, Component, Prop } from 'vue-property-decorator';
import UiButton from '@/components/button/ui-button.vue';

import { SubscriptionStatus } from '@/entities/payment/SubscriptionStatus';
import { SubscriptionPlansInnerNames } from '@/entities/payment/InnerNames';

import { Company, User } from '@/generated/graphql';

@Component({
	components: {
		UiButton,
	},
})
export default class ManagerInfo extends Vue {
	@Prop({ type: Object, required: true }) readonly company!: Company;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Object, required: true }) readonly subcription: any;
	@Prop({ type: Number, required: true }) readonly totalEnterManagers: any;

	get isTrialPeriod(): boolean {
		return (
			this.company.subscriptions[0]?.status === SubscriptionStatus.TRIALING
		);
	}
	get getCancelAt(): boolean {
		return this.subcription?.cancel_at_period_end;
	}
	get subcribedAdditionalManagersPlan(): boolean {
		return (
			this.subcription.subscription_plan.inner_name !==
				SubscriptionPlansInnerNames.STARTER &&
			this.subcription.subscription_plan.inner_name !==
				SubscriptionPlansInnerNames.GROWTH &&
			this.subcription.subscription_plan.inner_name !==
				SubscriptionPlansInnerNames.PREMIUM
		);
	}
}
